module.exports = __webpack_public_path__ + "img/7_52.b51782e1.png";